
export interface Group {
  id?: number;
  color?: string;
  name?: string;
  label: string;
}

export class Group implements Group {

}





// WEBPACK FOOTER //
// ./src/app/shared/models/group.model.ts